{
	"content": {
		"declarationDetailsSection": {
			"title": "Deklarasjonsdetaljer",
			"description": "For å opprette erklæringen kreves kundenavn, adresse og land til erklæringsinnehaveren. Informasjonen kan ikke endres i etterkant.",
			"customerLabel": "Kundekonto"
		},
		"provideDeclarationsDetailsSection": {
			"title": "Oppgi erklæringsdetaljer",
			"alertDescription": "Informasjonen du oppgir vil bli permanent registrert på erklæringen og kan ikke endres i etterkant.",
			"projectLabel": "Prosjektreferanse",
			"companyNameLabel": "Firmanavn",
			"streetLabel": "Gate",
			"zipCodeLabel": "Postnummer",
			"cityLabel": "By",
			"countryLabel": "Land"
		}
	},
	"summary": {
		"title": "Sammendrag",
		"declarationTypeTitle": "Erklæringstype",
		"customerProjectTitle": "Kundeprosjekt",
		"internalProjectOrProductTitle": "Internt prosjekt/produkt",
		"projectReferenceTitle": "Prosjektreferanse",
		"materialHeaderTitle": "Materiale",
		"quantityHeaderTitle": "Antall ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Allokerbare karbonreduksjoner ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Ikke-allokerbar karbonreduksjon ({{unit}})"
	},
	"errorMessages": {
		"projectRequired": "Prosjektreferanse er nødvendig",
		"companyNameRequired": "Firmanavn er påkrevd",
		"streetRequired": "Gate er påkrevd",
		"zipCodeRequired": "Postnummer kreves",
		"cityRequired": "By er påkrevd",
		"countryRequired": "Land er obligatorisk",
		"customerRequired": "Kunde kreves"
	},
	"reviewDeclarationDetailsModal": {
		"title": "Se gjennom erklæringssammendraget",
		"description": "Se gjennom dataene du har lagt inn for eventuelle feil.",
		"alertDescription": "Informasjonen du har oppgitt vil bli permanent registrert på erklæringen og kan ikke endres i etterkant.",
		"typeSectionTitle": "1. Type",
		"declarationTypeLabel": "Erklæringstype",
		"customerProjectTitle": "Kundeprosjekt",
		"internalProjectOrProductTitle": "Internt prosjekt/produkt",
		"projectReferenceLabel": "Prosjektreferanse",
		"materialSectionTitle": "2. Materiale",
		"materialHeaderTitle": "Materiale",
		"quantityHeaderTitle": "Antall ({{unit}})",
		"totalCarbonReductionsLabel": "Totale karbonreduksjoner ({{unit}})",
		"declarationSectionTitle": "3. Erklæring",
		"companyNameLabel": "Firmanavn",
		"streetLabel": "Gate",
		"zipCodeLabel": "Postnummer",
		"cityLabel": "By",
		"countryLabel": "Land",
		"backTitle": "Tilbake",
		"submitTitle": "Ja, alt stemmer"
	},
	"submitTitle": "Lag erklæring",
	"backTitle": "Tilbake"
}
